import React, { useState, useEffect } from 'react';
import { Button, TextField, Typography, Container, Box, Grid, CssBaseline, Paper, Modal, Backdrop, Fade, Snackbar, Alert } from '@mui/material';
import { Google as GoogleIcon, Apple as AppleIcon } from '@mui/icons-material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Signup = () => {
  const [email, setEmail] = useState('');
  const [first_name, setFirstName] = useState('');
  const [last_name, setLastName] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [openOtpModal, setOpenOtpModal] = useState(false);
  const [otpError, setOtpError] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [isRegistered, setIsRegistered] = useState(false);
  const [resendCooldown, setResendCooldown] = useState(0); // Cooldown timer in seconds
  const [role, setRole] = useState('admin'); // New role state with default value 'admin'
  let navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_BASE_URL;

  const theme = createTheme({
    palette: {
      primary: {
        main: '#1976d2',
      },
      secondary: {
        main: '#dc004e',
      },
      background: {
        default: '#ffffff',
      },
    },
  });

  // Effect to handle countdown
  useEffect(() => {
    let timer;
    if (resendCooldown > 0) {
      timer = setInterval(() => {
        setResendCooldown((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timer); // Cleanup on unmount or when cooldown changes
  }, [resendCooldown]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    if (isRegistered) {
      setOpenOtpModal(true);
      if (resendCooldown === 0) {
        await handleResendOtp();
      }
      setError('');
      return;
    }

    try {
      const response = await axios.post(`${apiUrl}/register-initial-admin/`, {
        email,
        first_name,
        last_name,
        role, // Added role to payload
        password,
        password2,
      });

      console.log('Signup Successful:', response.data);
      setOpenOtpModal(true);
      setIsRegistered(true);
      setResendCooldown(60);
      setError('');
    } catch (error) {
      console.error('Signup Failed:', error);
      if (error.response?.data?.email?.includes('user with this Email Address already exists.')) {
        setIsRegistered(true);
        setOpenOtpModal(true);
        if (resendCooldown === 0) {
          await handleResendOtp();
        }
        setError('User already exists. Please verify your OTP.');
      } else {
        setError(error.response?.data?.email?.[0] || 'Signup failed. Please try again.');
      }
    }
  };

  const handleOtpSubmit = async (event) => {
    event.preventDefault();
    setOtpError('');
    try {
      const response = await axios.post(`${apiUrl}/verify/`, {
        email,
        otp,
      });

      sessionStorage.setItem('authToken', response.data.token);
      setOpenOtpModal(false);
      setIsRegistered(false);
      setResendCooldown(0); // Reset cooldown on successful verification
      navigate('/');
    } catch (error) {
      console.error('OTP Verification Failed:', error);
      setOtpError(error.response?.data?.message || 'Invalid OTP. Please try again.');
    }
  };

  const handleResendOtp = async () => {
    try {
      const response = await axios.post(`${apiUrl}/resend-otp/`, {
        email,
      });

      setSnackbarMessage(response.data.message || 'OTP has been resent successfully');
      setSnackbarOpen(true);
      setOtpError('');
      setResendCooldown(60); // Start 1-minute cooldown
    } catch (error) {
      console.error('Resend OTP Failed:', error);
      setOtpError(error.response?.data?.message || 'Failed to resend OTP. Please try again.');
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container maxWidth="sm">
        <Paper elevation={3} style={{ padding: '20px', marginTop: '50px', minHeight: '60vh' }}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            component="form"
            onSubmit={handleSubmit}
          >
            <img src="/path/to/your/logo.png" alt="Logo" style={{ marginBottom: 20 }} />
            <Typography variant="h5" component="h1" gutterBottom>
              Sign Up
            </Typography>
            {/* <Button
              variant="contained"
              color="primary"
              fullWidth
              startIcon={<GoogleIcon />}
              style={{ marginBottom: 10 }}
            >
              Continue with Google
            </Button>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              startIcon={<AppleIcon />}
              style={{ marginBottom: 10 }}
            >
              Continue with Apple
            </Button>
            <Typography variant="body2" color="textSecondary" align="center" style={{ margin: '20px 0' }}>
              Or sign up with email
            </Typography> */}
            {error && (
              <Typography variant="body2" color="error" align="center" style={{ marginBottom: 10 }}>
                {error}
              </Typography>
            )}
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="Email"
              label="Email"
              name="email"
              autoComplete="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="First name"
              label="First Name"
              name="first_name"
              autoComplete="given-name"
              value={first_name}
              onChange={(e) => setFirstName(e.target.value)}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="Last name"
              label="Last Name"
              name="last_name"
              autoComplete="family-name"
              value={last_name}
              onChange={(e) => setLastName(e.target.value)}
            />
               <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="role"
              label="Role"
              name="role"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              disabled // Make field read-only since admin is default
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password2"
              label="Confirm Password"
              type="password"
              id="password2"
              autoComplete="new-password"
              value={password2}
              onChange={(e) => setPassword2(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              style={{ marginTop: 20 }}
            >
              Sign Up
            </Button>
          </Box>
        </Paper>
      </Container>

      <Modal
        aria-labelledby="otp-modal-title"
        aria-describedby="otp-modal-description"
        open={openOtpModal}
        onClose={() => {
          setOpenOtpModal(false);
          setOtpError('');
        }}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
            sx: {
              backgroundColor: 'rgba(0, 0, 0, 0.2)'
            }
          }
        }}
      >
        <Fade in={openOtpModal}>
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 400,
              bgcolor: 'background.paper',
              border: '2px solid #000',
              boxShadow: 24,
              p: 4,
            }}
          >
            <Typography variant="h6" component="h2" gutterBottom align="center">
              Enter OTP
            </Typography>
            <Typography variant="body2" color="textSecondary" align="center" style={{ marginBottom: 20 }}>
              We've sent an OTP to {email}. Please enter it below.
            </Typography>
            {otpError && (
              <Typography variant="body2" color="error" align="center" style={{ marginBottom: 10 }}>
                {otpError}
              </Typography>
            )}
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="otp"
              label="OTP"
              name="otp"
              autoFocus
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={handleOtpSubmit}
              style={{ marginTop: 20 }}
            >
              Verify OTP
            </Button>
            <Typography
              variant="body2"
              color={resendCooldown > 0 ? 'textSecondary' : 'primary'}
              align="center"
              style={{ marginTop: 10 }}
            >
              {resendCooldown > 0 ? 
                `Resend OTP in ${resendCooldown} seconds` : 
                <span style={{ cursor: 'pointer' }} onClick={handleResendOtp}>Resend OTP</span>}
            </Typography>
          </Box>
        </Fade>
      </Modal>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </ThemeProvider>
  );
};

export default Signup;
